export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Z"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Do"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Částka"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Převést"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Převod mezi vlastními účty"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Převody v peněžence"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Účty odesílatele a příjemce musí být různé"])}
}